module.exports = __webpack_public_path__ + "img/brm2.815735c6.jpg";